export async function toteCreateUseCase(toteData, toteRepository) {
    const result = await toteRepository.create(toteData);

    const entity = new toteRepository.model(result.data.success.arguments);
    
    if (!entity.isValid()) {
        throw new Error("tote inválido");
    }

    return entity;
}